import { useEffect, useRef, useState } from 'react';
import Popup from '../../../components/Popup/Popup';
import AgGridNew from '../../../components/grid/ag/ag-grid-new';
import Settings from '../../../inc/Settings';
import { connect } from 'react-redux';
import Button from '../../../components/inc/Button';
import Helper from '../../../inc/Helper';
import { getPopupMessageBasedOnStatus } from '../../../inc/Validation';
import axios from 'axios';
import NewOverlayLoader from '../../../components/PurchaseRequisition/common/NewOverlayLoader';
import { getNewValue } from '../../../components/grid/ag/commonFunctions/GridCommonFunctions';
import Api from '../../../inc/Api';

const SubWorkflowsModal = ({ hideSubworkflowModal, setDelete, addNode, mainModal, save, actionValue, currentHandleId, currentNode, onClickNode, setOnClickNode, user }) => {
    const [selectedWorkflow, setSelectedWorkflow] = useState(null);
    const [apiCallBtn, setApiCallBtn] = useState(false);
    const subWorkflowId = useRef(null);

    const query = new URLSearchParams(window.location.search);
    const templateId = query.get('id');
    const workflowId = query.get('wid');
    const workflowBodyId = query.get('to_id');
    const getNodeId = () => `${+new Date()}`;

    useEffect(() => {
        if(onClickNode){ getSubWorkflowDetails() }
    }, []);
 
    const checkInstance = async () => {
        try {
            let api = Api;
            api.setUserToken()
            const res = await api.axios().get(`${Settings.baseUrl}instance/check-by-body-id?body_id=${workflowBodyId}`);
            return res?.data?.instance_exist
        } catch (err) {
            return false;
        }
    };

    const getSubWorkflowDetails = () => {
        setApiCallBtn(true);
        let api = Api;
        api.setUserToken()
        api.axios().get(Settings.baseUrl + `subworkflow/get?body_id=${workflowBodyId}&node_id=${onClickNode}`).then((res) => {
            if (res.data.success) {
                setApiCallBtn(false);
                setSelectedWorkflow(res?.data?.data);
                subWorkflowId.current = res?.data?.data?.subworkflow_id;
            }
        }).catch((error) => {
            getPopupMessageBasedOnStatus(error);
            setApiCallBtn(false);
        })
    };

    const onDefaultWorkflowSelect = (params) => {
        if(!subWorkflowId?.current) return;

        setTimeout(() => {
            params?.api?.forEachNode((node) => {
                if (node?.data?.workflow_id == subWorkflowId?.current) {
                    node.setSelected(true);
                };
            });
        }, 300);
    };
 
    const onSelectionChanged = (event) => {
        let selectedRows = event?.api?.getSelectedRows();
        setSelectedWorkflow({...selectedRows[0], subworkflow_id: selectedRows[0]?.workflow_id});
    };

    const onPopupClose = (resetNodeId=true) => {
        hideSubworkflowModal(false);
        if(resetNodeId){ setOnClickNode() };
    };

    const onAddSubworkflow = async () => {
        try {
            setApiCallBtn(true);
            const NodeID = getNodeId();

            let payload = {
                node_id: NodeID,
                workflow_id: workflowId,
                body_id: workflowBodyId,
                parent_node_id: currentNode !== "1" ? +currentNode : null,
                parent_condition: currentHandleId != null ? currentHandleId === "a" : null,
                subworkflow_id: selectedWorkflow?.subworkflow_id
            };
        
            let api = Api;
            api.setUserToken()
            const res = await api.axios().post(Settings.baseUrl + 'subworkflow/create', payload);
            if (res.data.success) { 
                Helper.alert(res?.data?.message);
                setApiCallBtn(false);
                onPopupClose(false);
                mainModal(false);
                addNode(currentNode, actionValue, currentHandleId, NodeID, '');
                setTimeout(() => { save() }, 100);
            }
        } catch (error) {
            getPopupMessageBasedOnStatus(error);
            setApiCallBtn(false);
        }  
    };

    const onUpdateSubworkflow = async () => {
        try {
            setApiCallBtn(true);

            let payload = {
                node_id: +onClickNode,
                workflow_id: workflowId,
                body_id: workflowBodyId,
                parent_node_id: currentNode !== "1" ? +currentNode : null,
                parent_condition: currentHandleId != null ? currentHandleId === "a" : null,
                subworkflow_id: selectedWorkflow?.subworkflow_id
            };
        
            let api = Api;
            api.setUserToken()
            const res = await api.axios().post(Settings.baseUrl + 'subworkflow/update', payload);
            if (res.data.success) { 
                Helper.alert(res?.data?.message);
                setApiCallBtn(false);
                onPopupClose();
            }
        } catch (error) {
            getPopupMessageBasedOnStatus(error);
            setApiCallBtn(false);
        } 
    };

    const onDeleteSubWorkflow = async () => {
        setApiCallBtn(true);
        const instanceExist = await checkInstance();
        if (instanceExist) {
            Helper.alert("This workflow have instance, so you can't delete", 'error');
            setApiCallBtn(false);
        } else {
            const formData = { node_id: onClickNode };
            let api = Api;
            api.setUserToken()
            api.axios().post(Settings.baseUrl + 'workflow-node/delete', formData).then((res) => {
                if (res.data.success) {
                    Helper.alert(res.data.message);
                    setApiCallBtn(false);
                    setDelete(true);
                    onPopupClose();
                }
            }).catch((error) => {
                getPopupMessageBasedOnStatus(error);
                setApiCallBtn(false);
            })
        }
    };

    const onSaveHandler = async () => {
        if(!selectedWorkflow || !selectedWorkflow?.subworkflow_id){
            Helper.alert('Please select a workflow before proceeding', 'error');
            return;
        };

        if(!onClickNode){
            onAddSubworkflow();
        } else {
            const instanceExist = await checkInstance();
            if (instanceExist) {
                Helper.alert("This workflow have instance, so you can't edit", 'error');
                return;
            };

            onUpdateSubworkflow();
        };
    };

    const gridColumnHeaders = [
        { field: 'workflow_id', headerName: 'Workflow ID' },
        { field: 'name', headerName: 'Name', width: 350 },
        { field: 'description', headerName: 'Description', width: 350 }
    ];

    const handleFetchData = (response) => {
        const filtered = (response?.data?.data ?? []).filter(
            item => item.workflow_id != workflowId
        );

        return {
            rowData: filtered?.map(item => ({
                ...item,

                gridId: `${Date.now()}_${getNewValue()}`
            })),
            rowCount: filtered?.length
        };
    };
    return (
        <Popup onClose={onPopupClose} autoOpen={true}>
            {apiCallBtn ? <NewOverlayLoader isPopupInTab={true} /> : null}
            <h3>Sub-workflow</h3>
            <p>Create a nested workflow that runs within the main process, allowing complex tasks to be broken into smaller, manageable steps.</p>

            <AgGridNew 
                apiUrl={Settings.baseUrl + `workflow/get/child`}
                additionalParams={`?tenant_id=${user?.tenant_id}&template_id=${templateId}`} // change this ? to & once pagination is true
                filterAdditionalParams={`?tenant_id=${user?.tenant_id}&template_id=${templateId}`} // change this ? to & once pagination is true
                pagination={false}
                apiTokenRequired={false} 
                returnApiCondition={!!(onClickNode && subWorkflowId?.current)}
                hideDeleteBtn={true}
                onFirstDataRendered={onDefaultWorkflowSelect}
                fetchData={handleFetchData} 
                rowType={'single'}
                hideAddBtn={true}
                onSelectionChanged={onSelectionChanged}
                columnDefs={gridColumnHeaders} 
                height={500}
                uniqueField={'subworkflow_id'}
                gridId={'rs_sub_workflow_grid'}
            />

            <div className='d-flex justify-content-end mt-4'>
                <Button className="me-1" title="Close" onClick={onPopupClose} />
                { onClickNode && <Button isDisable={apiCallBtn} className="mx-1 red-btn-style" title="Delete" onClick={onDeleteSubWorkflow} /> }
                <Button isDisable={apiCallBtn || !selectedWorkflow?.subworkflow_id} className="ms-1" title='Save' icon={'/images/icons/save-white.svg'} isActive={true} onClick={onSaveHandler} />
            </div>
        </Popup>
    )
};

const mapStateToProps = (state) => {
    return { 
        user: state.auth.user
    }
};

export default connect(mapStateToProps) ((SubWorkflowsModal));